import React from "react";
import styles from "./productsTileCard.module.scss";
import { Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ProductsTileCard = ({
  title = "Tech Innovators Hackathon",
  subTitle = "Auditorium Hall, Block A",
}) => {

  const navigate=useNavigate()
  const path= subTitle==="Products" ? "/products/productMgmt" : "/products/category"
  return (
    <div className={styles.container} onClick={()=>navigate(path)}>
      <div className={styles.wrapper} />
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.subTitle}>{subTitle}</div>
      </div>
    </div>
  );
};

export default ProductsTileCard;
